/**
 * The poster headline is the woman's quote, and quotes vary from a few words
 * to a paragraph. The poster keeps its footprint: long quotes get set smaller
 * and, as a last resort, cut off after a fixed number of lines.
 */

export const HEADLINE_MAX_LINES = { collapsed: 6, expanded: 4 } as const;

/** Base size the design was tuned for (a one- or two-line quote). */
function baseSize(isMobile: boolean, isExpanded: boolean): number {
  if (isExpanded) return isMobile ? 17 : 20;
  return isMobile ? 22 : 28;
}

/**
 * Font size for a headline of `text`, stepping down as the quote gets longer:
 * short quotes keep the display size, medium ones drop a step, paragraphs
 * drop two so more of the sentence fits before the line clamp cuts in.
 */
export function headlineFontSize(
  text: string,
  isMobile: boolean,
  isExpanded: boolean,
): number {
  const base = baseSize(isMobile, isExpanded);
  const len = text.trim().length;
  const scale = len <= 70 ? 1 : len <= 140 ? 0.78 : 0.64;
  return Math.round(base * scale);
}
